export default (eventName, props = {}) => {
  if (typeof window === "undefined") return;

  const server = props.server || (window.s && window.s.server);
  const commonProps = {
    channel: "limited drops",
    pageName: `${server}|limited drops|landing page`,
    prop31: props.loginStatus,
    eVar10: props.customerId,
  };

  if (!props.status) {
    props.status = "500";
    props.breadcrumb = "asos-drops";
    props.errorMessage = "Request failed with status code 500";
  }

  const config = {
    "limited-drops-page-load": {
      linkVars: {
        prop8: "limited drops",
        eVar15: "limited drops",
        ...commonProps,
        ...props?.extraProps,
      },
      eventVars: {},
    },
    "limited-drops-message": {
      linkVars: {
        eVar106: `limited drops|${props.message}|message`,
        ...commonProps,
      },
      eventVars: {
        event172: "event172",
      },
    },
  };

  return config[eventName];
};
